import type { FC } from 'react'

import { MessagePopup } from '@skytech/ui'

import { Translation } from './translations/Translation'

export const NotFound: FC = () => (
  <MessagePopup
    isOpen
    title={<Translation id="Oops! We encountered an issue..." />}
    message={<Translation id="The page you are looking for does not exist." />}
  />
)
